"use strict";

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("@netgum/utils");

var Ens = /*#__PURE__*/function () {
  function Ens(options, eth, state) {
    _classCallCheck(this, Ens);

    this.options = options;
    this.eth = eth;
    this.state = state;
    this.state.ens$.next(this.buildState());
  }

  _createClass(Ens, [{
    key: "buildName",
    value: function buildName(label) {
      var rootName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var result = null;

      if (label) {
        var supportedRoots = this.state.ens.supportedRoots;

        if (supportedRoots.length) {
          if (!rootName) {
            rootName = supportedRoots[0].name;
          }

          var nameInfo = utils_1.getEnsNameInfo(label, rootName);

          if (nameInfo && nameInfo.rootNode && supportedRoots.find(function (_ref) {
            var name = _ref.name;
            return name === nameInfo.rootNode.name;
          })) {
            result = nameInfo.name;
          }
        }
      }

      return result;
    }
  }, {
    key: "buildState",
    value: function buildState() {
      var supportedRootNames = this.options.supportedRootNames;
      return {
        supportedRoots: supportedRootNames ? supportedRootNames.map(function (domain) {
          var name = utils_1.normalizeEnsName(domain);
          var nameHash = utils_1.getEnsNameHash(name);
          return {
            name: name,
            nameHash: nameHash
          };
        }) : []
      };
    }
  }]);

  return Ens;
}();

exports.Ens = Ens;